<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-form ref="programForm" v-model="valid" class="width-100">
        <v-flex>
          <h3 class="mb-3">{{ action }} Program</h3>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Program Name*"
            required
            v-model="editProgramObject.name"
            :rules="rules.required"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-select
            label="DSEC Partner*"
            required
            :rules="rules.required"
            v-model="editProgramObject.dsec_partner_id"
            :items="dsecPartners"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-flex>
        <v-flex>
        <div v-if="hasErrors" class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                There were issues trying to save this program. If this continues
                please submit feedback to the Amaze administrator.
              </div>
            </div>
          </div>

          <v-btn
            color="primary"
            class="mx-0"
            @click="saveProgram()"
            :disabled="disabled"
             v-if="!submitting"
            >Save</v-btn
          >
          <v-progress-circular v-else indeterminate />
        </v-flex>
      </v-form>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";
export default {
  mixins: [permissionsMixin],
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      usersLoading: false,
      search: "",
      editProgramObject: {},
      valid: false,
      disabled: false,
      hasErrors: false,
      submitting: false,
      partners: [],
      rules: {
        required: [v => !!v || "This field is required."]
      }
    };
  },
  computed: {
    action() {
      return this.editProgramObject.id ? "Edit" : "Add";
    },
    dsecPartners() {
      return this.partners ? this.partners.map(partner => {
        return {
          name: partner.name,
          id: partner.id
        };
      }) : [];
    }
  },
  watch: {
    partners(val) {
      // Do nothing for now.
    }
  },
  methods: {
    async getPartners() {
      if (this.partners && this.partners.length) {
        return;
      }
      this.loading = true;
      let partners = await this.$http.get("dsec/partners");
      this.partners = partners.body;
      this.loading = false;
    },
    async saveProgram() {
      if (this.$refs.programForm.validate()) {
        this.hasErrors = false;
        this.submitting = true;
        this.disabled = true;
        if (this.editProgramObject.id) {
          await this.$http.put(
            "dsec/program/" + this.editProgramObject.id,
            this.editProgramObject
          // eslint-disable-next-line handle-callback-err
          ).catch(error => {
            this.hasErrors = true;
          });
        } else {
          // eslint-disable-next-line handle-callback-err
          await this.$http.post("dsec/program", this.editProgramObject).catch(error => {
            this.hasErrors = true;
          });
        }
        this.disabled = false;
        this.submitting = false;

        if (!this.hasErrors) {
          EventBus.$emit("refreshPrograms");
          this.$emit("close");
        }
      }
    }
  },
  async mounted() {
    if (this.item.id) {
      let program = await this.$http.get("dsec/program/" + this.item.id);
      this.editProgramObject = program.body;
    }

    this.getPartners();
  }
};
</script>

<style></style>
